/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import { setNotification, locales, searchElementMatch, searchElementMatchWithoutLanguage } from 'utils';
import { get } from 'utils/methods';
import { APIS, ROUTES } from 'containers/MarketingSales/DiscountContainer/DiscountForm/Conditions/ConditionForm/ConditionForm.constants';
import * as DiscountTypes from '../types/discountTypes';
import * as DiscountApi from '../api/discountApi';
import * as DiscountActions from '../actions/discountActions';

const getLayout = state => state.layout;
const getDiscount = state => state.discount;

// A D D   N E W   D I S C O U N T
function* updateDiscountTranslate(action) {
    const type = 'add';
    const { locale } = yield select(getLayout);

    try {
        const data = {
            reseller_id: action.data.reseller_id,
            discount_id: action.data.discount_id,
            description: '',
        };

        const params = { bulk: [] };
        locales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === DiscountTypes.EDIT_DISCOUNT)) {
                params.bulk.push({
                    ...data,
                    ...action.data[lc],
                });
            }
        });

        const result = yield DiscountApi.updateTranslateDiscountApi(params);

        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }

        yield put(DiscountActions.updateTranslateDiscountRes(type, true, true));
        yield delay(50);
        yield put(DiscountActions.updateTranslateDiscountRes(type, false, false));
    } catch (e) {
        setNotification('error', locale, 'global.error', 'discount.notification.translateErrorFunction');
        yield put(DiscountActions.updateTranslateDiscountErr(type, false, false));
        console.log(e);
    }
}


function* addNewDiscountSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield DiscountApi.addNewDiscountApi(action.data);

        if (result.status === 202) {
            yield call(updateDiscountTranslate, action);

            yield put(DiscountActions.addNewDiscountRes());
            yield put(push('/marketing/discounts/'));

            setNotification('success', locale, 'global.success', 'discount.notification.addDiscountSuccess');
        } else {
            yield put(DiscountActions.addNewDiscountErr());
            setNotification('error', locale, 'global.error', 'discount.notification.addDiscountError');
        }
    } catch (e) {
        yield put(DiscountActions.addNewDiscountErr());
        setNotification('error', locale, 'global.error', 'discount.notification.addDiscountError');
        console.log(e);
    }
}

export function* addNewDiscountWatcher() {
    yield takeLatest(DiscountTypes.ADD_NEW_DISCOUNT, addNewDiscountSaga);
}
// A D D   N E W   D I S C O U N T


// L O A D   D I S C O U N T S
function* loadDiscountsSaga() {
    const { offset, limit, sort, filters } = yield select(getDiscount);
    const { locale } = yield select(getLayout);

    try {
        const params = { limit, offset };

        const sendFilters = {};

        if (filters['title.translate'] !== '') {
            sendFilters['title.translate'] = searchElementMatch(filters['title.translate'], locale);
        }

        if (filters.type !== '') {
            sendFilters.type = filters.type;
        }

        if (filters.resellers?.length > 0) {
            sendFilters.resellers = filters.resellers;
        }

        if (filters.start_date.length > 0) {
            sendFilters.start_date = { between: filters.start_date };
        }

        if (filters.end_date.length > 0) {
            sendFilters.end_date = { between: filters.end_date };
        }

        if (filters['conditions_groups.conditions'] !== '') {
            sendFilters['conditions_groups.conditions'] = {
                ...searchElementMatchWithoutLanguage(filters['conditions_groups.conditions'], locale),
                type: 'CODE_PROMO',
            };
        }

        if (filters.active !== '') {
            sendFilters.active = filters.active;
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'title') {
                params.sort_by = JSON.stringify({ 'title.original_title': sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const result = yield DiscountApi.getDiscountsApi(params);

        if (result.status === 200) {
            yield put(DiscountActions.loadDiscountsRes(result.data));
        }
    } catch (e) {
        yield put(DiscountActions.loadDiscountsErr());
        console.log(e);
    }
}

export function* loadDiscountsWatcher() {
    yield takeLatest(DiscountTypes.LOAD_DISCOUNTS, loadDiscountsSaga);
}
// L O A D   D I S C O U N T S


// L O A D   E D I T A B L E   D I S C O U N T
function* getFetchDataOfCondition(condition) {
    try {
        const URL = `${APIS[condition.type]}${ROUTES[condition.type]}`;

        const propID = ['CUSTOMER', 'BILLING_ACCOUNT'].includes(condition.type) ? '_id' : 'id';
        const params = {
            filter: JSON.stringify({ [propID]: condition.value }),
        };

        if (condition.type === 'CUSTOMER') {
            params.joins = JSON.stringify(['main_contact']);
        }

        const result = yield get(URL, params);

        if (result.status === 200) {
            return result.data.hits.map((hit) => {
                if (condition.type === 'CUSTOMER') {
                    const mainContact = hit.contacts.find(contact => contact.contact_type === 'MAIN');

                    return {
                        ...hit,
                        id: hit.id ? hit.id : hit._id,
                        name: `${mainContact.first_name} ${mainContact.last_name}`,
                    };
                }

                return { ...hit, id: hit.id ? hit.id : hit._id };
            });
        }

        return [];
    } catch (e) {
        console.log(e);
        return [];
    }
}

function* loadEditableDiscountSaga(action) {
    try {
        const params = { filter: JSON.stringify({ id: action.id }) };

        const result = yield DiscountApi.getDiscountsApi(params);

        if (result.status === 200) {
            const hit = result.data.hits[0];

            const { conditions } = hit.conditions_groups[0];
            for (let i = 0; i < conditions.length; i += 1) {
                if (['CODE_PROMO', 'CART_AMOUNT', 'FIRST_ORDER'].includes(conditions[i].type)) {
                    conditions[i].data = conditions[i].value;
                } else {
                    conditions[i].data = yield call(getFetchDataOfCondition, conditions[i]);
                }
            }
            yield delay(conditions.length * 100);

            const { actions } = hit;
            if (actions[0].type === 'YOU_GET') {
                for (let i = 0; i < actions.length; i += 1) {
                    actions[i].dataList = yield call(getFetchDataOfCondition, {
                        type: actions[i].product_groups?.length > 0 ? 'PRODUCT_GROUP' : 'CONFIGURATION',
                        value: actions[i].product_groups?.length > 0 ? actions[i].product_groups : actions[i].configurations,
                    });

                    [actions[i].dataList] = actions[i].dataList;
                }

                yield delay(actions.length * 100);
            }

            yield put(DiscountActions.loadEditableDiscountRes(hit));
        } else {
            yield put(DiscountActions.loadEditableDiscountErr());
        }
    } catch (e) {
        yield put(DiscountActions.loadEditableDiscountErr());
        console.log(e);
    }
}

export function* loadEditableDiscountWatcher() {
    yield takeLatest(DiscountTypes.LOAD_EDITABLE_DISCOUNT, loadEditableDiscountSaga);
}
// L O A D   E D I T A B L E   D I S C O U N T


// E D I T   D I S C O U N T
function* editDiscountSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield DiscountApi.editDiscountApi(action.data);

        if (result.status === 202) {
            yield call(updateDiscountTranslate, action);

            yield put(DiscountActions.editDiscountRes());
            yield put(push('/marketing/discounts/'));

            setNotification('success', locale, 'global.success', 'discount.notification.editDiscountSuccess');
        } else {
            yield put(DiscountActions.editDiscountErr());
            setNotification('error', locale, 'global.error', 'discount.notification.editDiscountError');
        }
    } catch (e) {
        yield put(DiscountActions.editDiscountErr());
        setNotification('error', locale, 'global.error', 'discount.notification.editDiscountError');
        console.log(e);
    }
}

export function* editDiscountWatcher() {
    yield takeLatest(DiscountTypes.EDIT_DISCOUNT, editDiscountSaga);
}
// E D I T   D I S C O U N T
